import { forwardRef, useEffect, useState } from "react";
import FilterInput from "../../SavedFilters/FilterInput";
import useModule from "../../../hooks/useModule";
import { Field } from "../../../types/TenantInterfaces";

interface Props {
  moduleAPIName: string;
  field: Field;
  value: any;
  onChange: any;
  disabled: boolean;
}

const FilterCreate = forwardRef<HTMLInputElement, Props>(
  ({ moduleAPIName, field, value, onChange, disabled }, ref) => {
    const filterMod =
      typeof field?.SourcesList === "string"
        ? field?.SourcesList
        : moduleAPIName;
    const { module } = useModule(filterMod);
    const [query, setQuery] = useState({ Filters: [] });

    useEffect(() => {
      setQuery(value || { Filters: [] });
    }, [value]);

    return (
      <FilterInput
        currentModule={module}
        moduleAPIName={filterMod}
        query={query}
        setQuery={(newQuery: any) => {
          setQuery(newQuery);
          onChange(field, newQuery);
        }}
        onApply={(newQuery: any) => {
          setQuery(newQuery);
          onChange(field, newQuery);
        }}
        onClear={() => {
          setQuery({ Filters: [] });
          onChange(field, null);
        }}
        fallbackMessage={"--"}
        disabled={disabled}
      />
    );
  }
);

export default FilterCreate;
